module.exports = __webpack_public_path__ + "img/tr.ac4572cc.svg";